// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__2tMXA","dark":"Skeleton_dark__OnSpP","wave":"Skeleton_wave__Fkcog"};